import React from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';

import { ContentSet } from 'components/Shared/Scaffolding';
import { Icon, GLYPHS } from 'components/Shared/Icon';
import SearchResultPreview from 'components/StyleSettings/SearchResultPreview';
import { SCAFFOLDING, TYPOGRAPHY, PAGINATION } from 'theme';

const PaginateContainer = styled.div`
    font-size: 1.125em;

    ul {
        padding: 0;
        text-align: center;
    }

    li {
        display: inline-block;
    }

    a {
        display: block;
        padding: ${PAGINATION.PADDING.Y} ${PAGINATION.PADDING.X};
        border-radius: 3px;
        outline: none !important;
        cursor: pointer;
        line-height: 1;
        text-decoration: none;
    }

    svg {
        display: inline-block;
        vertical-align: top;
    }

    .break {
        padding: ${PAGINATION.PADDING.Y} ${PAGINATION.PADDING.X};
        cursor: default;
    }

    .selected a {
        color: ${PAGINATION.COLOR.SELECTED};
        font-weight: 700;
        cursor: default;
    }

    .disabled a {
        opacity: 0.1;
        color: ${PAGINATION.COLOR.DISABLED};
        cursor: default;
    }
`;

const NoResults = styled.div`
    color: ${TYPOGRAPHY.COLOR_REDUCED};
    font-style: italic;
    text-align: center;
`;

const SearchResults = ({ selectedStyle, page, pageCount, styles, error, handlePageChange, handleStyleSelected }) => {
    return (
        <ContentSet spacing={SCAFFOLDING.GUTTER}>
            {error && (
                <NoResults>
                    There was an error getting the map styles.
                    <br /> Please try again.
                </NoResults>
            )}
            {!error && styles && styles.length === 0 && <NoResults>No results found.</NoResults>}
            {!error &&
                styles &&
                styles.length > 0 &&
                styles.map((s) => (
                    <SearchResultPreview
                        key={s.id}
                        style={s}
                        isSelected={selectedStyle.id === s.id}
                        selectStyle={handleStyleSelected}
                    />
                ))}
            {pageCount > 0 && (
                <PaginateContainer>
                    <ReactPaginate
                        initialPage={page}
                        forcePage={page}
                        pageCount={pageCount}
                        pageRangeDisplayed={2}
                        marginPagesDisplayed={1}
                        onPageChange={handlePageChange}
                        disableInitialCallback
                        previousLabel={<Icon glyph={GLYPHS.CHEVRON_LEFT} />}
                        nextLabel={<Icon glyph={GLYPHS.CHEVRON_RIGHT} />}
                    />
                </PaginateContainer>
            )}
        </ContentSet>
    );
};

export default SearchResults;
